import { Empty, Select, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import ItemSearchService from "services/item/ItemSearch";
import UserService from "services/user";

const itemSearchService = new ItemSearchService();
const userSearchService = new UserService();

function FilterSelect({ value, onChange, type }) {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [lstUser, setLstUser] = useState([]);

    useEffect(() => {
        if (type === "users") {
            fetchLstUser();
        }
    }, [type]);

    const fetchLstUser = async () => {
        const result = await userSearchService.list();
        const lstOption = result.map((user) => ({
            label: user.work_spaces[0].user_name,
            value: user.id,
        }));
        setOptions(lstOption);
        setLstUser(lstOption);
    };

    const handleSearch = useCallback(
        _.debounce(async (textSearch) => {
            setLoading(true);
            let lstOption = [];

            if (type === "items") {
                const result = await itemSearchService.search({ info: textSearch });
                lstOption = result.items.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
            } else if (type === "users") {
                lstOption = textSearch === "" ? lstUser : lstUser.filter((user) => user.label.toLowerCase().includes(textSearch.toLowerCase()));
            }

            setOptions(lstOption);
            setLoading(false);
        }, 500),
        [lstUser, type]
    );

    const handleChange = (value) => {
        onChange(value);
    };

    return (
        <Select
            mode="multiple"
            value={value}
            labelInValue
            onChange={handleChange}
            filterOption={false}
            onSearch={handleSearch}
            options={options}
            notFoundContent={loading ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        />
    );
}

export default FilterSelect;
